import { faCircleExclamation, faTriangleExclamation, faCircleInfo } from '@fortawesome/free-solid-svg-icons';

// Define the RiskCategory enum matching the Java enum
export const RiskCategoryEnum = {
  HIGH: {
    value: "HIGH",
    displayName: "HIGH URGENCY",
    description: "Needs attention today",
    color: "rgb(255, 140, 140)",
    colorFamily: 'red',
    icon: faCircleExclamation,
  },
  MEDIUM: {
    value: "MEDIUM",
    displayName: "MEDIUM URGENCY",
    description: "Needs attention this week",
    color: "rgb(254, 255, 196)",
    colorFamily: 'yellow',
    icon: faTriangleExclamation,
  },
  LOW: {
    value: "LOW",
    displayName: "LOW URGENCY",
    description: "No immediate action required",
    color: "rgb(196, 255, 211)",
    colorFamily: 'green',
    icon: faCircleInfo,
  }
};

const RISK_CATEGORY_CYCLE = [
  RiskCategoryEnum.HIGH.value,
  RiskCategoryEnum.MEDIUM.value,
  RiskCategoryEnum.LOW.value,
];

/**
 * Next urgency in the cycle: HIGH → MEDIUM → LOW → HIGH
 * @param {string} currentValue
 * @returns {string}
 */
export const getNextRiskCategory = (currentValue) => {
  const index = RISK_CATEGORY_CYCLE.indexOf(currentValue);
  return RISK_CATEGORY_CYCLE[(index + 1) % RISK_CATEGORY_CYCLE.length];
};

const formatRiskCategoryName = (value) => value.charAt(0) + value.slice(1).toLowerCase();

/**
 * Second line of the urgency tooltip: the next two values in the cycle.
 * @param {string} currentValue
 * @returns {string}
 */
export const getRiskCategoryCycleHint = (currentValue) => {
  const nextValue = getNextRiskCategory(currentValue);
  const afterValue = getNextRiskCategory(nextValue);
  return `Click to change to ${formatRiskCategoryName(nextValue)}/${formatRiskCategoryName(afterValue)}`;
}; 